const RANKING = [
  { rank: 1, title: '某知名品牌代言人翻车全记录：从签约到解约的72小时', heat: '9.8万', tag: '娱乐', trend: 'up' },
  { rank: 2, title: '内部员工匿名举报：某大厂绩效考核黑幕完整曝光', heat: '8.5万', tag: '科技', trend: 'up' },
  { rank: 3, title: '热播剧编剧真实身份被扒，竟是某高校在读研究生', heat: '7.2万', tag: '影视', trend: 'same' },
  { rank: 4, title: '某连锁餐饮后厨卫生状况触目惊心，前员工实拍证据', heat: '6.9万', tag: '消费', trend: 'up' },
  { rank: 5, title: '知名主播带货数据造假产业链揭秘，刷单团队运作细节', heat: '6.3万', tag: '直播', trend: 'down' },
  { rank: 6, title: '某城市学区房政策突变内幕，知情人士透露决策过程', heat: '5.7万', tag: '房产', trend: 'up' },
  { rank: 7, title: '顶流歌手新专辑疑似抄袭，对比音频在网络疯传引争议', heat: '5.1万', tag: '音乐', trend: 'same' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">爆料热榜</h2>
            <p className="text-sm text-foreground-500 mt-2">每日爆料大赛热门作品实时排名</p>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-foreground-400">更新时间: 10:42</span>
            <a href="#" className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap font-medium">
              完整榜单 <i className="ri-arrow-right-line ml-1"></i>
            </a>
          </div>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {RANKING.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 md:gap-4 px-4 md:px-6 py-4 border-b border-background-200/40 last:border-b-0 hover:bg-background-100/60 transition-colors cursor-pointer"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed truncate">{item.title}</p>
              </div>
              <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap flex-shrink-0">
                {item.tag}
              </span>
              <div className="flex items-center gap-1 text-xs flex-shrink-0 min-w-[60px] justify-end">
                {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                {item.trend === 'same' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
                <span className="text-foreground-500 font-medium">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}